import normalizeDateInput from './normalizeDateInput'

export const formatCampaignDateKey = (value) => {
  const isoDate = normalizeDateInput(value)

  if (!isoDate) {
    return null
  }

  return isoDate.replace(/-/g, '_')
}

export default formatCampaignDateKey
